module.exports = __webpack_public_path__ + "img/2.f1ded9c5.jpg";